import Phaser from 'phaser';
import { ItemType, ITEM_VISUAL } from '../config/items';
import { getTextResolution } from '../utils/display';

/**
 * 필드에 떠 있는 아이템 1개의 시각 표현.
 * 좌표/종류/id는 ItemManager가 권위를 가지며, 이 클래스는 렌더만 담당한다.
 */
export class Item {
  public readonly id: string;
  public readonly type: ItemType;
  public readonly x: number;
  public readonly y: number;

  private container: Phaser.GameObjects.Container;
  private bobTween?: Phaser.Tweens.Tween;

  constructor(scene: Phaser.Scene, id: string, type: ItemType, x: number, y: number) {
    this.id = id;
    this.type = type;
    this.x = x;
    this.y = y;

    const visual = ITEM_VISUAL[type];
    const radius = 22;

    const bg = scene.add.graphics();
    // 그림자
    bg.fillStyle(0x000000, 0.18);
    bg.fillCircle(0, 4, radius + 2);
    // 본체
    bg.fillStyle(0xffffff, 0.92);
    bg.fillCircle(0, 0, radius);
    // 종류별 테두리 (디버프는 빨강 계열)
    bg.lineStyle(visual.debuff ? 5 : 4, visual.ring, 1);
    bg.strokeCircle(0, 0, radius);

    const icon = scene.add
      .text(0, 1, visual.symbol, {
        fontSize: '26px',
        fontFamily: 'Nunito',
        resolution: getTextResolution(),
      })
      .setOrigin(0.5);

    this.container = scene.add.container(x, y, [bg, icon]);
    this.container.setDepth(8); // 영역(2) 위, 캐릭터(10) 아래

    // 위아래로 살짝 떠다니는 연출
    this.bobTween = scene.tweens.add({
      targets: this.container,
      y: y - 6,
      duration: 900,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }

  destroy(): void {
    this.bobTween?.remove();
    this.container.destroy();
  }
}
